<div>
  <div class="mb-3">
    <div class="text-3xl text-gray-800 dark:text-white">Mes Certificats</div>
    <p class="text-gray-600 text-base">Retrouvez ici vos certificats en cours</p>
  </div>
  <app-certificatlist-table [appels]="appelsBis"></app-certificatlist-table>
 
 
  
</div>
